import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import gallery1 from '../img/gallery-1.jpg';
import gallery2 from '../img/gallery-2.jpg';
import gallery3 from '../img/gallery-3.jpg';
import gallery4 from '../img/gallery-4.jpg';
import gallery5 from '../img/gallery-5.jpg';
import gallery6 from '../img/gallery-6.jpg';

const Gallery = () => {
  const galleryImages = [
    { src: gallery1, alt: 'Gallery Image 1' },
    { src: gallery2, alt: 'Gallery Image 2' },
    { src: gallery3, alt: 'Gallery Image 3' },
    { src: gallery4, alt: 'Gallery Image 4' },
    { src: gallery5, alt: 'Gallery Image 5' },
    { src: gallery6, alt: 'Gallery Image 6' },
  ];

  // Animation Variants
  const fadeInVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i = 1) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.3,
        duration: 0.5,
      },
    }),
  };

  return (
    <div className="our-gallery-container py-12 bg-gray-100 p-12">
      <div className="container mx-auto px-4 p-12">
        <motion.h2
          className="text-3xl font-semibold text-center mb-8 text-blue-900"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          Our Gallery
        </motion.h2>
        <motion.p
          className="text-center text-blue-600 mb-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          Take a glimpse into our professional nursing services and care moments.
        </motion.p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <motion.div
              key={index}
              className="relative overflow-hidden rounded-lg shadow-lg group"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInVariants}
              custom={index}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-60 object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-white text-lg font-semibold">View Details</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
